<template>
  <div class="passenger">
    <div class="picture">
      <img src="../../../assets/user.svg" width="50" height="50" class="image">
    </div>
    <div class="passenger--info">
      <div class="info--header"> Passenger Info </div>
      <div style="margin-bottom: 5px">{{passenger.full_name}}</div>
      <div style="margin-bottom: 5px">Gender: {{passenger.gender}}</div>
      <div style="margin-bottom: 5px">{{passenger.email}}</div>
      <div style="margin-bottom: 5px">+234{{passenger.tel_no}}</div>
      <div style="margin-bottom: 5px">Car {{ passenger.route_section }}. Seat Nos: {{ passenger.seat_nos }}</div>
      <div style="margin-bottom: 5px">
        PAYMENT: <b>
        <span v-if="passenger.is_offline"> OFFLINE </span>
        <span v-else> ONLINE </span>
      </b>
      </div>
      <div style="margin-bottom: 5px"> TICKET: <span class="ticket--ref"><b>{{ passenger.ref }}</b></span></div>
      <div v-show="passenger.others.length > 0 ">
        <el-button @click="showOthers(passenger)"
           size="mini" type="info" plain>
          Adults {{ passenger.others.length }} </el-button>
      </div>
    </div>
    <div v-if="showMore" class="passenger--info--nok">
      <div class="info--header"> Next of Kin </div>
      <div> {{passenger.nok_name}} </div>
      <div> {{passenger.nok_tel_no}} </div>
    </div>
    <div  class="actions">
      <div v-if="showMore" class="passenger--trip--info">
        <div> <strong>ROUTE:  </strong> {{ passenger.route.description }}</div>
        <div> <strong>DEP DATE: </strong> {{ passenger.dep_date }} </div>
        <div> <strong>STATUS: </strong> {{ passenger.checked_in? 'BOARDED': 'NOT-BOARDED' }} </div>
      </div>
      <el-button @click="showMore =  !showMore" type="text">
        {{ showMore ? 'Hide details' : 'More details' }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassengerItem',
  props: ['passenger', 'onViewAdults'],
  data () {
    return {
      showMore: false
    }
  },

  methods: {
    showOthers (passenger) {
      this.onViewAdults(passenger)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/passengers/Item.vue